import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ui from 'redux-ui';
import './InteractiveLayer.css';
import Canvas from '../canvas/Canvas';
import { CALLIGRAFIA } from './../../helpers/coverHelper';

class InteractiveLayer extends Component {
  constructor(props) {
    super(props);
    this.layerRef = '';
  }

  spineText() {
    const { pageNumber, spine } = this.props;
    const textStyle = {
      color: spine.color,
    };
    if (pageNumber === 0) {
      return (
        <div className="spine-text">
          <p style={textStyle}>{spine.text}</p>
        </div>
      );
    }
    return null;
  }


  render() {
    const {
      placeholders,
      backgroundColor,
      lang,
      spine,
      backgroundImage,
      context,
      isPhotoCover,
      backgroundPlaceholders,
      coverType,
    } = this.props;

    const isCalligrafiaCover = coverType === CALLIGRAFIA && isPhotoCover;

    const style = {
      background: backgroundColor,
      backgroundImage: backgroundImage !== '' && !isCalligrafiaCover ? `url(${encodeURI(backgroundImage)})` : '',
    };

    // For pro editor
    const spineStyle = {
      backgroundColor: spine.backgroundColor,
    };


    return (

      <div
        ref={(layerRef) => { this.layerRef = layerRef; }}
        className="InteractiveLayer"
        style={style}
      >
        <Canvas
          placeholders={placeholders}
          lang={lang}
          backgroundPlaceholders={backgroundPlaceholders}
        />
      </div>
    );
  }
}

InteractiveLayer.defaultProps = {
  pageNumber: 1,
  spine: {},
  placeholders: [],
  lang: {},
  backgroundColor: '#ffffff',
  backgroundImage: '',
  context: '',
  isPhotoCover: false,
  coverType: '',
};

InteractiveLayer.propTypes = {
  pageNumber: PropTypes.number,
  spine: PropTypes.object,
  placeholders: PropTypes.array,
  backgroundColor: PropTypes.string,
  lang: PropTypes.object,
  backgroundImage: PropTypes.string,
  context: PropTypes.string,
  isPhotoCover: PropTypes.bool,
  coverType: PropTypes.string,
};

export default ui({
  key: 'EditorToolsUI',
  state: {
    marginType: '',
  },
})(InteractiveLayer);



// WEBPACK FOOTER //
// ./src/components/interactive-layer/InteractiveLayer.jsx